import React, { useEffect, useMemo } from "react";
import { useSearch } from "../../contexts/SearchContext";
import "./FlightBookingFlowMockup.css";
import { BookingFlowStepShell } from "./flightBookingMockup/BookingFlowStepShell";
import { BookingFlowProvider } from "./flightBookingMockup/context/BookingFlowContext";
import { FlightRealProposalSubmitProvider } from "./flightBookingMockup/context/FlightRealProposalSubmitContext";
import { computeFlightBookingSearchGate } from "./flightBookingSearchGate";
import { useFlightBookingMockupLdsSync } from "./flightBookingMockup/hooks/useFlightBookingMockupLdsSync";
import FlightWizardShell from "./flightBookingMockup/wizard/FlightWizardShell";
import FlightSearchToResultsBridge from "./flightBookingMockup/FlightSearchToResultsBridge";
import FlightResultsImmersiveBridge from "./flightBookingMockup/FlightResultsImmersiveBridge";
import FlightBookingPathSync from "./flightBookingMockup/FlightBookingPathSync";
import FlightDetailsStepCard from "./flightBookingMockup/FlightDetailsStepCard";
import ResultsStepCard from "./flightBookingMockup/ResultsStepCard";
import SelfComposePickStepCard from "./flightBookingMockup/SelfComposePickStepCard";
import FlightSearchLive from "../../features/flightEngineV2/search/FlightSearchLive";
import PassengersLive from "../../features/flightEngineV2/passengers/PassengersLive";
import ExtrasLive from "../../features/flightEngineV2/extras/ExtrasLive";
import ReviewLive from "../../features/flightEngineV2/review/ReviewLive";
import PaymentLive from "../../features/flightEngineV2/payment/PaymentLive";
import ConfirmationLive from "../../features/flightEngineV2/confirmation/ConfirmationLive";
// שלב מלון עתידי: AddHotelStepCard.jsx (לא מחובר ל־BOOKING_FLOW_STEP_ORDER)

function FlightBookingMockupLdsBridge() {
  useFlightBookingMockupLdsSync();
  return null;
}

function FlightBookingFlowMockupShell() {
  const {
    flightTripType,
    parallelRoundTripFlightSearchCompleted,
    roundTripFlightResults,
    outboundOneWayFlightResults,
    inboundOneWayFlightResults,
  } = useSearch();

  const searchGate = useMemo(
    () =>
      computeFlightBookingSearchGate({
        flightTripType,
        parallelRoundTripFlightSearchCompleted,
        roundTripFlightResults,
        outboundOneWayFlightResults,
        inboundOneWayFlightResults,
      }),
    [
      flightTripType,
      parallelRoundTripFlightSearchCompleted,
      roundTripFlightResults,
      outboundOneWayFlightResults,
      inboundOneWayFlightResults,
    ]
  );

  useEffect(() => {
    console.log("[FlightBookingMockup] searchGate snapshot", {
      roundTrip: searchGate.rtCount,
      outbound: searchGate.outboundCount,
      inbound: searchGate.inboundCount,
      needsSelfComposePickStep: searchGate.needsSelfComposePickStep,
      partialSelfCompose: searchGate.partialSelfCompose,
      outboundOnlyNoReturn: searchGate.outboundOnlyNoReturn,
      parallelOk: searchGate.parallelOk,
    });
  }, [searchGate]);

  return (
    <BookingFlowProvider searchGate={searchGate}>
      <FlightRealProposalSubmitProvider>
      <FlightBookingMockupLdsBridge />
      <FlightSearchToResultsBridge />
      <FlightResultsImmersiveBridge />
      <FlightBookingPathSync />
      <FlightWizardShell>
        <BookingFlowStepShell step="search">
          <FlightSearchLive />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="results">
          <ResultsStepCard />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="selfComposePick">
          <SelfComposePickStepCard />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="flightDetails">
          <FlightDetailsStepCard />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="passengers">
          <PassengersLive />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="extras">
          <ExtrasLive />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="review">
          <ReviewLive />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="holdConfirmation">
          <ConfirmationLive />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="draftPayment">
          <PaymentLive />
        </BookingFlowStepShell>
        <BookingFlowStepShell step="success">
          <ConfirmationLive />
        </BookingFlowStepShell>
      </FlightWizardShell>
      </FlightRealProposalSubmitProvider>
    </BookingFlowProvider>
  );
}

export default function FlightBookingFlowMockup() {
  return <FlightBookingFlowMockupShell />;
}
